import {
    CalendarCommonModule,
    CalendarMonthModule,
    CalendarWeekModule,
    CalendarEvent,
    CalendarView,
} from 'angular-calendar';
import {animate, state, style, transition, trigger} from '@angular/animations';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {Kalender, KalenderService as KalenderApiService} from 'kkm-library';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {Component, OnInit, effect, inject} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {MatTooltipModule} from '@angular/material/tooltip';
import {MatButtonModule} from '@angular/material/button';
import {MatTableModule} from '@angular/material/table';
import {ActivatedRoute, Router} from '@angular/router';
import {MatListModule} from '@angular/material/list';
import {MatMenuModule} from '@angular/material/menu';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatDialog} from '@angular/material/dialog';
import {AuthenticationService} from 'kkm-library';
import {NgClass, DatePipe} from '@angular/common';
import {lastValueFrom, Subscription} from 'rxjs';
import {isSameDay, isSameMonth} from 'date-fns';
import {DeviceScaleService} from 'kkm-library';
import {CopyPasteService} from 'kkm-library';
import {TermineService} from 'kkm-library';
import {FormsModule} from '@angular/forms';
import {SEOService} from 'kkm-library';
import {Termin} from 'kkm-library';

import {TerminDetailsDialogComponent} from '../termin-details-dialog/termin-details-dialog.component';
import {KalenderFormDialogComponent} from '../kalender-form-dialog/kalender-form-dialog.component';
import {TerminFormComponent} from '../termin-form/termin-form.component';
import {KalenderService} from '../kalender.service';

//  Kalender Doku
// https://mattlewis92.github.io/angular-calendar/#/kitchen-sink

@Component({
    templateUrl: './kalender-page.component.html',
    styleUrls: ['./kalender-page.component.scss'],
    animations: [
        trigger('detailExpand', [
            state('collapsed', style({height: '0px', minHeight: '0'})),
            state('expanded', style({height: '*'})),
            transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
        ]),
    ],
    imports: [
        MatCardModule,
        MatButtonModule,
        CalendarCommonModule,
        MatButtonToggleModule,
        FormsModule,
        MatProgressSpinnerModule,
        MatTableModule,
        MatIconModule,
        MatTooltipModule,
        MatMenuModule,
        CalendarMonthModule,
        CalendarWeekModule,
        NgClass,
        DatePipe,
        MatExpansionModule,
        MatListModule,
    ],
})
export class KalenderPageComponent implements OnInit {
    public authService = inject(AuthenticationService);
    private terminService = inject(TermineService);
    protected copyPasteService = inject(CopyPasteService);
    public deviceScaleService = inject(DeviceScaleService);
    private kalenderApiService = inject(KalenderApiService);
    private kalenderService = inject(KalenderService); // Vorladen
    public dialog = inject(MatDialog);
    private activatedRoute = inject(ActivatedRoute);
    private router = inject(Router);
    private seo = inject(SEOService);

    constructor() {
        effect(() => {
            this.isLoggedIn = this.authService.loginStatus();
            this.setTableColumns();
        });
    }

    sitetitle = this.seo.getTitle();

    isLoggedIn = false;
    isLoading = true;
    showNewTermin = false;

    defaultcolor = {
        primary: '#1e90ff',
        secondary: '#D1E8FF',
    };

    /** Statusvairable für den Ansicht Button */
    Kalenderansicht = 'Liste';

    view: CalendarView = CalendarView.Day;
    CalendarView = CalendarView;
    viewDate: Date = new Date();
    events: CalendarEvent[] = [];
    activeDayIsOpen = false;
    aktYear = new Date().getFullYear();
    heute = new Date();

    minKalenderDate = new Date('01/01/2000');
    maxKalenderDate = new Date('01/01/2031');

    // Listen Tabelle
    dataSource: Termin[] = [];
    termineAll: Termin[] = [];
    termine: Termin[] = [];
    columnsToDisplay = ['color', 'datum', 'betreff' /*, 'expand' */];
    columnsToDisplayWithExpand = [...this.columnsToDisplay];
    expandedElement: Termin | null = null;

    showTerminForm = false;
    editTermin: Termin | undefined;

    kalender: Kalender[] = [];
    selectedKalender: Kalender[] = [];

    terminSub?: Subscription;
    terminDialogId: number | undefined = undefined;

    ngOnInit(): void {
        console.log('init');

        this.terminSub = this.activatedRoute.queryParamMap.subscribe(params => {
            const terminId = params.get('terminId');
            console.log(terminId);
            this.terminSub?.unsubscribe();
            if (terminId) {
                this.terminDialogId = +terminId;
            }
        });

        this.initTerminlistData(true);
        this.initkalenderData();
        this.setTableColumns();
        this.isLoggedIn = this.authService.isLoggedIn();
    }

    setTableColumns(): void {
        if (this.deviceScaleService.isMobile()) {
            this.columnsToDisplay = ['mobile' /*'expand'*/];
        }

        if (this.isLoggedIn) {
            this.columnsToDisplayWithExpand = [...this.columnsToDisplay, 'buttonsMobile'];
        } else {
            this.columnsToDisplayWithExpand = [...this.columnsToDisplay];
        }
    }

    async initkalenderData(): Promise<void> {
        if (this.authService.isLoggedIn()) {
            this.selectedKalender = this.kalender = await lastValueFrom(this.kalenderApiService.getKalender());
            this.showNewTermin = this.kalender.some(kal => kal.editable);
        }
    }

    async initTerminlistData(open = false): Promise<void> {
        this.seo.updateTitle(`${this.sitetitle} ${this.aktYear}`);
        this.termine = this.termineAll = await lastValueFrom(this.terminService.getAllTermine(this.aktYear));
        this.createCalendarEvents();
        this.filterTermine();
        this.isLoading = false;

        if (open && this.terminDialogId) {
            const termine = this.termine.filter(t => t.id == this.terminDialogId);
            if (termine.length == 1) {
                this.openTerminDetails(termine[0]);
            }
        }
    }

    filterTermine() {
        if (this.kalender.length != 0) {
            this.termine = this.termineAll.filter(termin => {
                if (termin.kalender && termin.kalender.id)
                    return this.selectedKalender.some(k => k.id === termin.kalender!.id);
                return false;
            });
            this.createCalendarEvents();
        }
    }

    createCalendarEvents() {
        const events: CalendarEvent[] = this.termine.map(termin => {
            // let allday = false;

            const allday =
                (!termin.datum_bis &&
                    new Date(termin.datum).getHours() == 0 &&
                    new Date(termin.datum).getMinutes() == 0) ||
                (termin.datum_bis &&
                    new Date(termin.datum).getHours() == 0 &&
                    new Date(termin.datum).getMinutes() == 0 &&
                    new Date(termin.datum_bis).getHours() == 0 &&
                    new Date(termin.datum_bis).getMinutes() == 0);

            const event: CalendarEvent = {
                start: new Date(termin.datum),
                title: termin.betreff,
                color: {primary: termin.kalender?.farbe || '#1e90ff', secondary: '#D1E8FF'},
                allDay: allday,
                meta: termin,
            };

            if (termin.datum_bis) {
                event.end = new Date(termin.datum_bis);
            }

            return event;
        });
        this.events = events;
    }

    openKalenderDialog(kalender: Kalender | undefined = undefined): void {
        const dialogRef = this.dialog.open(KalenderFormDialogComponent, {
            // height: '90%',
            width: '95%',
            disableClose: true,
            data: {
                kalender: kalender,
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.initkalenderData();
            }
        });
    }

    viewDateChange(): void {
        this.closeOpenMonthViewDay();
        if (this.viewDate.getFullYear() != this.aktYear) {
            this.aktYear = this.viewDate.getFullYear();
            this.initTerminlistData();
        }
    }

    closeOpenMonthViewDay(): void {
        this.activeDayIsOpen = false;
    }

    // Info Zeile für Tag öffnen
    dayClicked({date, events}: {date: Date; events: CalendarEvent[]}): void {
        if (isSameMonth(date, this.viewDate)) {
            if ((isSameDay(this.viewDate, date) && this.activeDayIsOpen === true) || events.length === 0) {
                this.activeDayIsOpen = false;
            } else {
                this.activeDayIsOpen = true;
            }
            this.viewDate = date;
        }
    }

    // Von Monatsansicht zu Liste für Details wechseln
    handleEvent(action: string, event: CalendarEvent): void {
        this.openTerminDetails(event.meta);
        // this.view = CalendarView.Day;
        // this.expandedElement = event.meta;
        // this.scroll('#termin-' + event.meta.id);
    }

    scroll(id: string) {
        console.log(`scrolling to ${id}`);
        // const el = document.getElementById(id);
        // el?.scrollIntoView({ behavior: 'smooth' });
        setTimeout(() => {
            document.querySelector(id)?.scrollIntoView({behavior: 'smooth', block: 'center'});
        }, 500);
    }

    openTerminDetails(termin: Termin | undefined): void {
        if (termin && termin.id)
            this.router.navigate([], {
                queryParams: {terminId: termin?.id},
                queryParamsHandling: 'merge',
                replaceUrl: true,
            });

        const dialogRef = this.dialog.open(TerminDetailsDialogComponent, {
            // height: '90%',
            width: '400px',
            disableClose: false,
            data: {
                termin: termin,
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.initTerminlistData();
            }
        });
    }

    newTerminEntry(): void {
        this.editTerminEntry(undefined);
    }

    editTerminEntry(termin: Termin | undefined): void {
        const dialogRef = this.dialog.open(TerminFormComponent, {
            // height: '90%',
            width: '95%',
            disableClose: true,
            data: {
                termin: termin,
            },
        });

        dialogRef.afterClosed().subscribe(result => {
            if (result) {
                this.initTerminlistData();
            }
        });
    }

    copyTerminEntry(termin: Termin): void {
        const editTermin = Object.assign(termin, {id: 0});
        this.editTerminEntry(editTermin);
    }

    deleteTerminEntry(termin: Termin): void {
        if (termin.id) {
            lastValueFrom(this.terminService.deleteTermin(termin.id)).then(() => {
                this.initTerminlistData();
            });
        }
    }
}
